
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { setAlert } from "../../redux/actions/alerts";

import { IoSearch } from "react-icons/io5";

import styles from "../../styles/Components/Shared/ListPageHeader.module.css";

const Search = ({
    searchProps: {
        searchTerm, 
        setSearchTerm,
        placeholder,
        searchFunction,
        getContent,
        minimumLength = 2,
        searchDelay = 1500,
        hideError,
        addedStyles = {}
    },
    setAlert,
}) => {
    const [searched, setSearched] = useState(false)

    useEffect(() => {
        let timeout
        
        timeout = setTimeout(() => {
            if(searched){
                return
            }
            
            if (searchTerm && searchTerm.length < (minimumLength)) {

                if (!hideError) {
                    setAlert(`Query must be ${minimumLength} characters or longer`, "danger");
                }
            } else if (searchTerm.length >= (minimumLength)) {
                searchFunction(searchTerm)
                setSearched(true)
            } else {
                setSearchTerm('');
                
                if (getContent) {
                    getContent()
                }
            }
        }, searchDelay);

        return ()=> clearTimeout(timeout)

    }, [searchTerm, searched])

    const searchContent = (term = searchTerm) => {
        setSearched(true)
        searchFunction(term)

        if (!term) {
            setSearchTerm('')
        }
    };
    
    const searchChange = (e) => {
        if (searched) {
            setSearched(false)
        }
        setSearchTerm(e.target.value)
    }

    return (
            
            <div className={styles.header_search_container} style={addedStyles}>
                <input 
                    type="text" 
                    placeholder={placeholder} 
                    className={styles.header_search_input} 
                    onChange={(e) => searchChange(e)} 
                    onKeyDown={(e) => e.key === 'Enter' ? searchContent() : ''}
                    value={searchTerm}
                />
                {searchTerm ? 
                    <button className={styles.header_clear_btn} 
                        onClick={() => searchContent('')}
                    >
                        Clear
                    </button>
                : null}
                <button className={styles.header_search_btn} 
                    onClick={() => searchContent()}
                >
                    Search
                    <IoSearch size={18}/>
                </button>
            </div>

    );
};


const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    setAlert,
})(Search);

